"use strict";

var curry = require("./curry.js");

var reduce = require("./reduce.js");

module.exports = curry(function join(sep, iter) {
  return reduce((acc, a) => `${acc}${sep}${a}`, iter);
});